import React, { useLayoutEffect } from 'react'
import { PersonalDetailsFormContainer } from './style'
import { EPersonalDetailsFormSteps } from '../../../../../../../types/enums/EPersonalDetailsFormSteps'
import { PersonalDetailsFormPersonalInfo } from './components/personal-details-form-personal-info/PersonalDetailsFormPersonalInfo'
import { PersonalDetailsFormExtraPersonalInfo } from './components/personal-details-form-extra-personal-info/PersonalDetailsFormExtraPersonalInfo'
import { ProgressBar } from 'shared/components/progress-bar/ProgressBar'
import { useAppSelector } from 'store/store'
import { PersonalDetailsIdentityProvider } from './components/personal-details-form-identity-provider/PersonalDetailsFormIdentityProvider'

export const PersonalDetailsForm: React.FC = () => {
  const personalDataStep = useAppSelector(
    (state) => state.layout.personalDetailsStep,
  )

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [personalDataStep])

  const personalDetailsStep = () => {
    switch (personalDataStep) {
      case EPersonalDetailsFormSteps.identityProvider:
        return <PersonalDetailsIdentityProvider />
      case EPersonalDetailsFormSteps.personalInfo:
        return <PersonalDetailsFormPersonalInfo />
      case EPersonalDetailsFormSteps.extraPersonalInfo:
        return <PersonalDetailsFormExtraPersonalInfo />
      default:
        return <PersonalDetailsIdentityProvider />
    }
  }

  const getProgress = (personalDataStep: EPersonalDetailsFormSteps): number => {
    switch (personalDataStep) {
      case EPersonalDetailsFormSteps.personalInfo:
        return 50
      case EPersonalDetailsFormSteps.identityProvider:
        return 75
      case EPersonalDetailsFormSteps.extraPersonalInfo:
        return 100
    }
  }
  const progress = getProgress(personalDataStep)

  return (
    <PersonalDetailsFormContainer>
      {personalDetailsStep()}
      <ProgressBar progress={progress} />
    </PersonalDetailsFormContainer>
  )
}
